import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import * as styles from './styles';

function DynamicBars() {
    return (
        <Box aria-hidden="true" sx={styles.barsWrapper}>
            <Box sx={styles.barsInner}>
                <Box sx={styles.bars.warm1} />
                <Box sx={styles.bars.warm2} />
                <Box sx={styles.bars.cool2} />
                <Box sx={styles.bars.cool1} />
                <Box sx={styles.bars.cool3} />
                <Box sx={styles.bars.white3} />
            </Box>
        </Box>
    );
}

function Hero({ onBrowse, onWhatsHot }) {
    return (
        <Box component="section" sx={styles.section}>
            <DynamicBars />

            <Container maxWidth="xl" sx={styles.container}>

                <Typography variant="overline" sx={styles.eyebrow}>
                    The official calendar of the world's best brands
                </Typography>

                <Typography variant="h1" sx={styles.headline}>
                    Live your life in{' '}
                    <Box component="span" sx={styles.gradientWarm}>colour.</Box>
                    <br />
                    Own your{' '}
                    <Box component="span" sx={styles.gradientCool}>time.</Box>
                </Typography>

                <Typography variant="body1" sx={styles.subheading}>
                    Discover the world's leading publisher brands and sync their events —
                    fixtures, releases, drops, conferences and more — straight to your
                    personal digital calendar.
                </Typography>

                <Box sx={styles.ctaRow}>
                    <Button variant="contained" size="large" onClick={onBrowse}>
                        Browse publishers
                    </Button>

                    <Box sx={styles.whatsHotWrapper}>
                        <Button
                            onClick={onWhatsHot}
                            startIcon={<LocalFireDepartmentIcon sx={styles.whatsHotIcon} />}
                            sx={styles.whatsHotButton}
                        >
                            See What's Hot!
                        </Button>
                    </Box>

                    <Box sx={styles.liveIndicator}>
                        <Box sx={styles.liveDot} />
                        Live sync · Google Calendar, Outlook & more
                    </Box>
                </Box>

            </Container>
        </Box>
    );
}

export default Hero;
